import { render, staticRenderFns } from "./NhapLieuCtyTTTaiChinhInputs.vue?vue&type=template&id=f7e972a4&scoped=true"
import script from "./NhapLieuCtyTTTaiChinhInputs.vue?vue&type=script&lang=ts"
export * from "./NhapLieuCtyTTTaiChinhInputs.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7e972a4",
  null
  
)

export default component.exports